export class ListenerCallbackInfo<T>
{
    constructor(public callback: ListenerCallback<T>, public title?: string, public priority = 0) {
    }
}

export type ListenerCallback<T> = (data: T) => void | Promise<void>;